import {
  ImageCard as UIImageCard,
  type ImageCardProps as UIImageCardProps,
} from "@webmotors/eleanor-ui";

export type ImageCardProps = UIImageCardProps;

export function ImageCard(props: Readonly<ImageCardProps>) {
  return <UIImageCard {...props} />;
}
